import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./filter.css";
import { Dropdown } from "react-bootstrap";
import { APIResponseCodes, filterParameters } from "../../utils/constants/keys.constants";
import { useAppDispatch, useAppSelector } from "../../store/storeRequests";
import { setFilterName, setPageData, setPageNumber } from "../../store/pageData/pageData.slice";
import StoreSelectors from "../../utils/constants/StoreSelectors.constants";
import { postDetails } from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import transformString from "../../utils/helpers/transformString";
import { NavList } from "../../utils/constants/navigation";
 
const Filter: React.FunctionComponent = () => {
 
  const dispatch = useAppDispatch();
  const { searchString, filterName, apiType } = useAppSelector(StoreSelectors.PAGE_STATE);
  const { access } = useAppSelector(StoreSelectors.USER_STATE);
  const location = useLocation();
 
  useEffect(() => {
    if (location.pathname === NavList.MARKET_PLACE) {
      if (location.state?.fromSearch) return;
      handleFilter(filterName);
    }
  }, [location.pathname]);
 
  const handleFilter = async (option: any) => {
    dispatch(setFilterName(option));
    dispatch(setPageNumber(0));
 
    if (location.pathname.includes(NavList.MARKET_PLACE)) {
      const payload = {
        search: searchString,
        page_no: 1,
        group_type: option.toLowerCase() === 'all' ? '' : option.toLowerCase() === 'read only' ? 'e-cas' : option.toLowerCase(),
      }
      const response = await postDetails(APIList.FILTER_BY_TYPE, payload, () => handleFilter(option));
      if (response.statusCode === APIResponseCodes.SUCCESS) {
        dispatch(setPageData(response.data));
      }
    }
    else if (location.pathname.includes(NavList.API_LISTING_PRODUCTION) && access.hasProdAccess) {
      const payload = {
        page_no: 1,
        category: option.toLowerCase() === 'all' ? '' : option.toLowerCase(),
        env: apiType,
      }
      const response = await postDetails(APIList.GET_FILTERED_PROD_APIS, payload, () => handleFilter(option));
      if (response.statusCode === APIResponseCodes.SUCCESS) {
        dispatch(setPageData(response.data));
      }
    } else if (location.pathname.includes(NavList.API_LISTING_LIVE) && access.hasProdAccess) {
      const payload = {
        page_no: 1,
        category: option.toLowerCase() === 'all' ? '' : option.toLowerCase(),
        env: 'live',
      }
      const response = await postDetails(APIList.GET_FILTERED_PROD_APIS, payload, () => handleFilter(option));
      if (response.statusCode === APIResponseCodes.SUCCESS) {
        dispatch(setPageData(response.data));
      }
    }
  };
 
  return (
    <section className="mf-api-filters">
      <div className="d-flex align-items-center api-listing d-none d-md-flex d-lg-flex">
        {filterParameters.map((filterParameter) => (
          <p
            key={filterParameter.filterID}
            data-selected={filterName.toLowerCase() === filterParameter.filterName.toLowerCase()}
            onClick={() => handleFilter(filterParameter.filterName)}
            className="mb-0 cursor-pointer font-14 text-capitalize weight-500 api-listing-item"
          >
            {filterParameter.filterName}
          </p>
        ))}
      </div>
      <Dropdown className="mf-filter-dropdown d-md-none d-lg-none">
        <Dropdown.Toggle className="mf-filter-dropdown-btn text-capitalize text-sec-color font-16 weight-500 text-start w-100"> {filterName.length === 0 ? 'All' : filterName} </Dropdown.Toggle>
        <Dropdown.Menu className="mf-filter-dropdown-menu">
          {filterParameters.map((filterParameter) => (
            <Dropdown.Item
              key={filterParameter.filterID}
              data-selected={transformString(filterName, " ", "") === transformString(filterParameter.filterName, " ", "")}
              onClick={() => handleFilter(filterParameter.filterName)}
              className="mf-filter-dropdown-item mb-0 cursor-pointer font-14 text-capitalize weight-500 api-listing-item"
            >
              {filterParameter.filterName}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </section>
  );
};
 
export default Filter;
